export default "__VITE_ASSET__N2LsHmS7__"